module.exports = __webpack_public_path__ + "images/emoji/sandal.c5982bd653a50ccbb478.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sandal.png
// module id = Gg8c
// module chunks = 2